<template>
  <div class="merchant-manage-page">
    <div class="page-header">
      <div class="page-header__info">
        <h2 class="page-title">企业管理</h2>
        <p class="page-desc">管理合伙人企业申请，审核企业资质与配置</p>
      </div>
    </div>

    <div class="manage-card">
      <div class="table-wrap">
        <el-table :data="records" stripe row-key="id" size="small">
          <el-table-column fixed label="ID" prop="id" width="80"/>
          <el-table-column label="用户ID" prop="wechatMpId" width="120" show-overflow-tooltip/>
          <el-table-column label="店铺名" prop="store" min-width="150" show-overflow-tooltip/>
          <el-table-column label="店铺电话" prop="phone" width="120"/>
          <el-table-column label="昵称" prop="nickname" width="120" show-overflow-tooltip/>
          <el-table-column label="地区" prop="areaName" width="120" show-overflow-tooltip/>
          <el-table-column label="详细地址" prop="address" min-width="200" show-overflow-tooltip/>
          <el-table-column label="备注" prop="remark" min-width="150" show-overflow-tooltip/>
          <el-table-column align="center" label="状态" width="100">
            <template slot-scope="{ row }">
              <el-tag :type="row.state == '0' ? 'warning' : row.state == '1' ? 'danger' : 'success'" size="mini">
                {{ row.state == '0' ? '审核中' : row.state == '1' ? '审核失败' : '审核通过' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="视频通话" width="90">
            <template slot-scope="{ row }">
              <el-tag :type="row.isVideoChat === '是' ? 'success' : 'info'" effect="plain" size="mini">
                {{ row.isVideoChat === '是' ? '开启' : '关闭' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="企业审核" width="100">
            <template slot-scope="{ row }">
              <el-tag :type="row.requireCheck === '否' ? 'success' : 'warning'" effect="plain" size="mini">
                {{ row.requireCheck === '否' ? '免审核' : '需审核' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="拒绝原因" prop="reply" min-width="150" show-overflow-tooltip/>
          <el-table-column label="创建时间" prop="createdTime" width="160" show-overflow-tooltip/>
          <el-table-column label="申请时间" prop="updatedTime" width="160" show-overflow-tooltip/>
          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="{ row }">
              <div class="row-actions">
                <el-button size="mini" type="text" @click="onShowUrls(row.urls)" :disabled="!row.urls.length">
                  查看执照
                </el-button>
                <el-dropdown trigger="click" @command="cmd => handleRowCommand(cmd, row)">
                  <el-button size="mini" type="text">
                    更多<i class="el-icon-arrow-down el-icon--right"/>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="row.state=='2'" command="edit">修改</el-dropdown-item>
                    <el-dropdown-item v-if="row.state!='2'" command="pass">通过</el-dropdown-item>
                    <el-dropdown-item command="reject">不通过</el-dropdown-item>
                    <el-dropdown-item command="resetPwd" divided>重置密码</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-footer">
        <page :current="current" :size="size" :total="total"/>
      </div>
    </div>

    <el-dialog
        title="查看执照"
        :visible.sync="showUrls"
        width="30%"
        center
    >

      <div v-for="(url,i) in urls" :key="i" style="text-align: center">
        <div class="demo-image__preview">
          <el-image
              style="width: 300px; height: 300px"
              :src="fileBaseUrl+url"
              :preview-src-list="[fileBaseUrl+url]">
          </el-image>
        </div>
      </div>

    </el-dialog>

    <el-dialog
        title="提示"
        :visible.sync="showCheck"
        width="30%"
        center>

      您是否对ID为 {{checkState.id}} 的申请执行 {{isEdit?'修改':checkState.state=='1'?'不通过':'通过'}}？

      <el-form label-position="left" label-width="120px" :model="checkState" v-show="checkState.state=='2'" ref="ruleForm">
        <el-form-item label="详细地址" prop="address"
                      :rules="[
                        { required: true, message: '不能为空'},
                        ]">
          <el-input v-model.number="checkState.address" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="企业类型">
          <el-cascader
              @change="newsTypeChange"
              :value="checkState.newsTypeIds"
              :options="newsTypes"
              :props="{ multiple: true, checkStrictly: true }"
              clearable></el-cascader>
        </el-form-item>
        <el-form-item label="市场">
          <el-select v-model="checkState.marketPlaces" multiple clearable placeholder="请选择">
            <el-option
                v-for="item in marketPlaces"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺数量" prop="shopSize"
                      :rules="[
                        { required: true, message: '不能为空'},
                        { type: 'number', message: '必须为数字值'},
                        ]">
          <el-input v-model.number="checkState.shopSize" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="下单模板">
          <el-select v-model="checkState.templates" multiple clearable placeholder="请选择">
            <el-option
                v-for="item in messageTemplates"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传企业个数" prop="newsCount"
                      :rules="[
                        { required: true, message: '不能为空'},
                        { type: 'number', message: '必须为数字值'},
                        { validator: notLtNum0, trigger: 'blur' }
                        ]">
          <el-input v-model.number="checkState.newsCount" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="企业视频通话" prop="isVideoChat"
                      :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
          <el-select v-model="checkState.isVideoChat" placeholder="请选择">
            <el-option v-for="item in isVideoChats" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="企业审核" prop="requireCheck"
                      :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
          <el-select v-model="checkState.requireCheck" placeholder="请选择">
            <el-option v-for="item in requireChecks" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
          <div class="form-tip">设为「免审核」后，合伙人新增/编辑企业将自动通过审核</div>
        </el-form-item>
      </el-form>

      <el-form label-position="left" label-width="80px" :model="checkState" v-show="checkState.state=='1'">
        <el-form-item label="拒绝原因">
          <el-input v-model="checkState.reply" maxlength="100" placeholder="请输入原因"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showCheck = false">取 消</el-button>
        <el-button type="primary" @click="doCheck('ruleForm')">确 定</el-button>
      </span>

    </el-dialog>

    <el-dialog
        title="重置密码"
        :visible.sync="showResetPwd"
        width="30%"
        center
    >

      是否给ID为 {{resetPwdId}} 重置密码？
      <span slot="footer" class="dialog-footer">
        <el-button @click="showResetPwd = false">取 消</el-button>
        <el-button type="primary" @click="doResetPwd">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import storeShopPage from "@/api/merchant/page";
import Page from "@/components/Page.vue";
import agencyGetNewsMessageTemplates from "@/api/user/agency/agencyGetNewsMessageTemplates";
import adminGetNewsType from "@/api/user/admin-controler/adminGetNewsType";
import listMerchantNewsTypes from "@/api/merchant/newsType/listMerchantNewsTypes";
import listMerchantNewsTypeTemplates from "@/api/merchant/newsType/listMerchantNewsTypeTemplates";
import {notLtNum0} from "@/utils/check";
import {Message} from "element-ui";
import check from "@/api/merchant/check";
import resetPwd from "@/api/merchant/resetPwd";
import marketPlaceList from "@/api/store/StoreMarketPlace/list";
import getMarketPlaceIdsByMerchantId from "@/api/user/merchant/getMarketPlaceIdsByMerchantId";

export default {
  name: "MerchantManage",
  components: {Page},
  data() {
    return {
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      current:1,
      size:10,
      total: 0,
      params: {},
      records: [],

      showUrls:false,
      urls:[],

      messageTemplates:[],
      newsTypes:[],

      showCheck:false,
      isEdit:false,
      checkState:{
        id:undefined,
        state:'0',
        address: '',
        newsTypeIds:[],
        marketPlaces:[],
        shopSize:1,
        templates:[],
        isVideoChat:'否',
        requireCheck:'是',
        newsCount:1,
        reply:'',

        newsTypes:[],
      },

      marketPlaces:[],
      isVideoChats:[
        {
          value: '是',
          label: '开启'
        },
        {
          value: '否',
          label: '关闭'
        },
      ],
      requireChecks:[
        {
          value: '是',
          label: '需要审核'
        },
        {
          value: '否',
          label: '免审核'
        },
      ],

      showResetPwd:false,
      resetPwdId:undefined,



    }
  },
  methods: {
    notLtNum0,
    // 处理行命令
    handleRowCommand(command, row) {
      switch (command) {
        case 'edit':
          this.check(row, '2', true)
          break
        case 'pass':
          this.check(row, '2')
          break
        case 'reject':
          this.check(row, '1')
          break
        case 'resetPwd':
          this.onShowResetPwd(row)
          break
      }
    },
    doResetPwd(){
      resetPwd(this.resetPwdId).then(res=>{
        if (res.code===1){
          Message({message:'成功',type:'success',duration:3000})
          this.showResetPwd=false
        }else{
          Message({message:'失败',type:'error',duration:3000})
        }
      })
    },
    onShowResetPwd(row){
      this.resetPwdId=row.id
      this.showResetPwd=true
    },
    newsTypeChange(e){
      let parents = new Set()
      for (let i=0;i<e.length;i++){
        if(e[i].length==1)parents.add(e[i][0])
      }
      let arr = []
      for (let i=0;i<e.length;i++){
        if(e[i].length==2){
          let parent = e[i][0]
          if(!parents.has(parent)){
            parents.add(parent)
            arr.push([parent])
          }
        }
        arr.push(e[i])
      }
      this.checkState.newsTypeIds=arr
    },
    formatNewsTypeIds(params){
      let newsTypeIds = params.newsTypeIds
      let result = []
      for (let i=0;i<newsTypeIds.length;i++){
        let newsType = newsTypeIds[i]
        result.push({merchantId:params.id,newsTypeId:newsType[newsType.length-1]})
      }
      params.newsTypes=result
    },
    doCheck(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.checkState))
          this.formatNewsTypeIds(params)
          params.marketPlaceIds = params.marketPlaces
          check(this.checkState.id, params).then(res=>{
            if(res.code==1){
              Message({
                message: '成功',
                type:'success',
                duration:3000
              })
              this.showCheck=false
              this.fetchData()
            }else{
              Message({
                message: '失败',
                type:'error',
                duration:3000
              })
            }
          })
        } else {
          return false;
        }
      });
    },
    check(row, state, isEdit){
      this.isEdit=isEdit?true:false
      this.checkState.state=state
      //分配
      // 企业类型
      // 企业下单模板
      listMerchantNewsTypes(row.id).then(res=>{
        const data = res.data
        const result = []
        for (let i=0;i<data.length;i++){
          const type = data[i]
          if(type.parentId===0){
            result.push([type.newsTypeId])
          }else{
            result.push([type.parentId,type.newsTypeId])
          }
        }
        this.checkState.newsTypeIds=result

        listMerchantNewsTypeTemplates(row.id).then(messageIds=>{
          this.checkState.templates=messageIds.data
          getMarketPlaceIdsByMerchantId(row.id).then(marketPlaceIds=>{
            this.checkState.marketPlaces=marketPlaceIds.data

            const merchant = JSON.parse(JSON.stringify(row))
            this.checkState.id=merchant.id
            this.checkState.address=merchant.address
            this.checkState.shopSize=merchant.shopSize
            this.checkState.isVideoChat=merchant.isVideoChat || '否'
            this.checkState.requireCheck=merchant.requireCheck || '是'
            this.checkState.newsCount=merchant.newsCount
            this.checkState.reply=merchant.reply
            this.showCheck=true
          })
        })
      })
    },
    onShowUrls(urls){
      this.urls=urls
      this.showUrls=true
    },
    search(){
      this.fetchData()
    },
    reset(){
      this.current=1
      this.params = {}
      this.fetchData()
    },
    getNewsType(){
      adminGetNewsType().then(res=>{
        let types = res.data
        types.sort((a,b)=>a.order-b.order)

        let map = new Map()
        for (let i = 0; i < types.length; i++) {
          let type = types[i]
          if(type.parentId==0) continue
          let children = map.get(type.parentId)
          if(!children){
            children = []
          }
          children.push({
            value:type.id,
            label:type.name
          })
          map.set(type.parentId,children)
        }

        let data = []
        for (let i = 0; i < types.length; i++) {
          let type = types[i]
          if(type.parentId>0) continue
          if(map.has(type.id)){
            type.children = map.get(type.id)
          }
          data.push({
            value:type.id,
            label:type.name,
            children:type.children
          })
        }

        this.newsTypes = data
      })
    },
    getMessageTemplates(){
      agencyGetNewsMessageTemplates().then(res=>{
        let data = res.data
        let arr = []
        for(let i=0;i<data.length;i++){
          arr.push({value:data[i].id,label:data[i].name})
        }
        this.messageTemplates=arr
      })
    },
    getMarketPlaces(){
      marketPlaceList().then(res=>{
        let data = res.data
        data.sort((a,b)=>a.order-b.order)
        let arr = []
        for(let i=0;i<data.length;i++){
          arr.push({value:data[i].id,label:data[i].name})
        }
        this.marketPlaces=arr
      })
    },
    fetchData(){
      storeShopPage(this.current,this.size,this.params).then(res=>{
        this.records=res.data.data
        this.total=res.data.total
      })
    },
  },

  mounted() {
    this.getNewsType()
    this.getMessageTemplates()
    this.getMarketPlaces()
    this.fetchData()
  },

}
</script>

<style lang="scss" scoped>
.merchant-manage-page {
  padding: 20px;
  box-sizing: border-box;
  min-height: calc(100vh - 56px);
  background: #f5f7fa;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 0 4px;

  &__info {
    flex: 1;
  }
}

.page-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.page-desc {
  margin: 6px 0 0;
  font-size: 13px;
  color: #9ca3af;
}

.manage-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.table-wrap {
  padding: 0;
}

.row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.table-footer {
  padding: 16px 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f0f2f5;
}

.form-tip {
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--app-text-secondary, #909399);
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 60px;

  .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 60px;
    display: block;
  }
}

@media (max-width: 768px) {
  .merchant-manage-page {
    padding: 12px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .table-wrap {
    padding: 0;
  }
}
</style>
